import(/* webpackMode: "eager", webpackExports: ["default"] */ "/var/www/businessstorepro/app/src/components/PagesComponents/ComingSoon/ComingSoon.tsx");
